import { configureStore } from '@reduxjs/toolkit'
import { firebaseFunctionsApi } from '../../services/FirebaseFunctions/FirebaseFunctionsApi';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import searchTextReducer from '../features/searchText/searchTextSlice';
import cartStateReducer from '../features/cartState/cartStateSlice';
import betaAccessReducer from '../features/betaAccess/betaAccessSlice';
import productSearchCacheReducer from '../features/productSearchCache/productSearchCache';
import currentUserReducer from '../features/current_user/currentUserSlice';
import orderAdminAccessReducer from '../features/orderAdminAccess/orderAdminAccessSlice';
import addPaymentModalReducer from '../features/addPaymentModal/addPaymentModalSlice';

// Redux-Persist config
const persistConfig = {
  key: "root",
  storage,
};

// Persisted (Cached) Reducers
const persistedCartStateReducer = persistReducer(persistConfig, cartStateReducer);
const persistedBetaAccessReducer = persistReducer(persistConfig, betaAccessReducer);
const persistedCurrentUserReducer = persistReducer(persistConfig, currentUserReducer);
const persistedOrderAdminAccessReducer = persistReducer(persistConfig, orderAdminAccessReducer);
const persistedProductSearchCacheReducer = persistReducer(persistConfig, productSearchCacheReducer)

export const store = configureStore({
  reducer: {
    searchText: searchTextReducer,
    cartState: persistedCartStateReducer,
    betaAccess : persistedBetaAccessReducer,
    productSearchCache : persistedProductSearchCacheReducer,
    currentUser : persistedCurrentUserReducer,
    orderAdminAccess : persistedOrderAdminAccessReducer,
    addPaymentModal : addPaymentModalReducer,
    [firebaseFunctionsApi.reducerPath] : firebaseFunctionsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(firebaseFunctionsApi.middleware)
})

export const persistor = persistStore(store);

export default store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
